import { render, staticRenderFns } from "./EditTeletag.vue?vue&type=template&id=94abf1ac"
import script from "./EditTeletag.vue?vue&type=script&lang=js"
export * from "./EditTeletag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports